import {ApiClient} from "../../utils/ApiClient";

export default class Subscription extends ApiClient {
    static resourceName = "subscriptions";
}
